module.exports = (__parcel__import__("lmDyq")).then(() => parcelRequire('fyWP3'));